<template>
  <div class="content">
    <card>
      <div class="row">
        <div class="col-md-2">
          <el-select @change="getPopups" class="select-primary" size="large" placeholder="선택" v-model="state.state">
            <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
        </div>
        <base-button @click="goPopupForm()" type="default">팝업 등록</base-button>
        <base-button @click="setOrder()" type="default">순서 변경</base-button>
      </div>
    </card>
    <draggable class="row" handle=".handle" v-model="popups" @start="drag = true" @end="drag = false">
      <div class="col-sm-3 handle" v-for="(item, index) in popups">
        <card class="card">
          <div class="row">
            <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.title" />
            <img v-else src="@/assets/img/blip-logo.png" />
          </div>
          <p class="card-text">{{ item.name }}</p>
          <p class="card-text">{{ item.typeName }}</p>
          <p class="card-text">{{ item.startTime }}</p>
          <p>{{ item.endTime }}</p>
          <p v-if="item.group" class="card-text">그룹: {{ item.group }}</p>
          <base-button @click="goPopupForm(item.id)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import { formatDateTime } from "../../util/DateUtils";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    Card,
    BaseButton,
  },
  async created() {
    await this.getPopups();
  },
  data() {
    return {
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      popups: [],
    };
  },
  methods: {
    async getPopups() {
      return this.$axios.get(`/popup`, { params: { state: this.state.state } }).then((res) => {
        this.popups = res.data.data.map((popup) => {
          popup.imageFileUrl = window.Endpoints.imageServerUrl + popup.images?.find((i) => i.code === "ko").imageFileId;
          popup.startTime = formatDateTime(popup.startTime);
          popup.endTime = formatDateTime(popup.endTime);
          return popup;
        });
      });
    },
    async setOrder() {
      await this.$axios.put(`/popup/order`, { params: { ids: this.popups.map((popup) => popup.id) } });
      Toast.success("순서가 변경되었습니다");
    },
    goPopupForm(popupId) {
      if (popupId) {
        this.$router.push(`/banner/popupForm?popupId=${popupId}`);
      } else {
        this.$router.push(`/banner/popupForm`);
      }
    },
  },
};
</script>
<style></style>
